import React from 'react'
import { observer } from 'mobx-react'
import { ListItem, ListItemSegment, ListItemTitle } from 'components/ListItem'
import './styles.sass'

export default observer(function WorkspaceListItem({ workspace }) {
  return (
    <ListItem className="workspace-list-item">
      <ListItemSegment pad stretch>
        <ListItemTitle>
          <span className="friendly-name">{workspace.name}</span>
        </ListItemTitle>
      </ListItemSegment>
    </ListItem>
  )
})
